<table class="table table-bordered table-hover">
  <thead class="table-dark">
    <tr>
      @if (showClient) { <th>Client</th> }
      <th>Encounter Type</th>
      <th>Earliest<br /> Record</th>
      <th>Last<br/> Received</th>
      <th>Encounter Count</th>
      <th>Current Eligibility Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    @if (clientEncounterTypeEligibilities.length > 0) {
      @for (eligibility of clientEncounterTypeEligibilities; track trackByEligibility($index, eligibility)) {
        <tr>
          @if (showClient) { <td>{{ eligibility.client.humanizedName }}</td> }
          <td>{{ eligibility.encounterType || '(No Encounter Type)' }}</td>
          <td>{{ eligibility.earliestEncounterDate | date: 'MM/dd/yyyy' | blankValueDash }}</td>
          <td>{{ eligibility.lastReceivedDate | date: 'MM/dd/yyyy' | blankValueDash }}</td>
          <td>{{ eligibility.count | blankValueDash }}</td>
          <td class="eligibility-status" [ngClass]="eligibility.eligibility">
            {{ keyedEligibilityStatusOptions[eligibility.eligibility].display }}
          </td>
          @if(eligibility.encounterTypeIneligibleByDefaultEnabled) {
            @if(!eligibility.encounterType) {
              <td>Eligibility Update Not Available</td>
            } @else {
              <td class="text-nowrap">
                @switch(eligibility.eligibility) {
                  @case(eligibilityStatuses.new) {
                    <button
                      type="button"
                      class="btn btn-secondary action-button"
                      (click)="onMarkEligibleClick(eligibility)">
                      Mark Eligible
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary action-button"
                      (click)="onMarkIneligibleClick(eligibility)">
                      Mark Ineligible
                    </button>
                  }
                  @case(eligibilityStatuses.eligible) {
                    <button
                      type="button"
                      class="btn btn-secondary action-button"
                      (click)="onMarkIneligibleClick(eligibility)">
                      Mark Ineligible
                    </button>
                  }
                  @case(eligibilityStatuses.ineligible) {
                    <button
                      type="button"
                      class="btn btn-secondary action-button"
                      (click)="onMarkEligibleClick(eligibility)">
                      Mark Eligible
                    </button>
                  }
                }
              </td>
            }
          } @else {
            <td class="bg-light">This client does not manage encounter data in the app</td>
          }
        </tr>
      }
    } @else {
      <tr>
        <td [attr.colspan]="showClient ? 7 : 6">No encounter type eligibility data found.</td>
      </tr>
    }
  </tbody>
</table>
